import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import TestDrive from 'pages/toyotaOfficialAccount/pnp/TestDrive';
import DownloadCalendar from 'pages/toyotaOfficialAccount/pnp/DownloadCalendar';
import Error404 from 'pages/errorPages/Error404';

const PnpWebviewRouter = () => {
  useEffect(() => {
    document.title = `TOYOTA`;
  }, []);

  return (
    <Routes>
      <Route path="/testDrive" element={<TestDrive />}></Route>
      <Route path="/downloadCalendar" element={<DownloadCalendar />}></Route>
      <Route path="*" element={<Error404 />}></Route>
    </Routes>
  );
};

export default PnpWebviewRouter;
